import React, { useContext, useState } from "react";
import CART from "components/context/CartContext";
import CheckoutAction from "./Checkout";
import Loading from "components/loadings/Loading";
import styles from "styles/profilepage.module.css";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

export default function SelectedEvents() {
  const { cart, dispatch } = useContext(CART);
  const [loading, setLoading] = useState(false);

  const deleteEvent = (id) => {
    dispatch({ type: "REMOVE", payload: id });
  };

  const CartItem = ({ data }) => {
    return (
      <div className={styles.profileEventscard}>
        <div className={styles.profileSelectedEvents}>{data.name}</div>
        <div className={styles.moneynDel}>
          Rs.{data.price}
          <div
            className={styles.profileDelBtn}
            title="Delete"
            onClick={() => {
              deleteEvent(data.id);
            }}
          >
            <DeleteForeverIcon fontSize="medium" />
          </div>
        </div>
      </div>
    );
  };

  if (cart?.length === 0) {
    return "";
  }

  return (
    <>
      <div className={styles.selectedEvents}>
        <div className={styles.selectedEventsBtn}>
          <h2>Selected Events</h2>
          <h2>{getTotalAmount(cart)}</h2>
          <br />
          <hr />
          <CheckoutAction setLoading={setLoading} />
        </div>
        <div className={styles.profileSelectedEventsList}>
          {cart.map((data, index) => {
            return <CartItem key={index.toString()} data={data} />;
          })}
        </div>
      </div>

      {loading && <Loading />}
    </>
  );
}

const getTotalAmount = (cart) => {
  return cart.reduce((partialSum, event) => partialSum + event.price, 0);
};
